import request from '@src/utils/request'

export const fetcher = async <T = unknown>(
	url: string,
	method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',
	options?: {
		body?: unknown
		loading?: boolean
	}
): Promise<T> => {
	const response = await request({
		url,
		method,
		body: options?.body,
		loading: options?.loading
	})
	return response as T
}
